import React from "react";
import clsx from "clsx";
import { makeStyles, createStyles } from "@mui/styles";

const useStyles = makeStyles(() => {
  return createStyles({
    bodyContainer: {
      "& .rhrCgGridContainer .cg-slide:first-child": {
        paddingTop: "0px"
      }
    }
  });
});

const Body = props => {
  const classes = useStyles();

  return (
    <main
      id="main"
      className={clsx(classes.bodyContainer)}
      style={{
        flex: 1,
        position: "relative",
        zIndex: 1099,
        minHeight: "80vh"
      }}
      {...props}
    />
  );
};

export default Body;
